import Cookies from "js-cookie";
import { url } from "../constants/constants";
import axios from "axios";

const axiosInstance = axios.create({
  baseURL: url,
  headers: {
    "Content-Type": "application/json",
  },
});

export const ACCESS_TOKEN_KEY = "accessToken";
export const REFRESH_TOKEN_KEY = "refreshToken";

export function getSession(key = ACCESS_TOKEN_KEY) {
  return Cookies.get(key);
}

export function setSession(key, value) {
  Cookies.set(key, value);
}

export function removeSession(key) {
  Cookies.remove(key);
}

export function flushStorage() {
  removeSession(ACCESS_TOKEN_KEY);
  removeSession(REFRESH_TOKEN_KEY);
}

export async function flushSession() {
  // await window.fetch(`${url}/auth/logout/admin`, {
  //   method: "GET",
  //   credentials: "same-origin",
  //   headers: {
  //     Accept: "application/json",
  //     "Content-Type": "application/json",
  //     Cache: "no-cache",
  //     Cookie: `refreshToken=${getSession()}`,
  //   },
  // });

  flushStorage();
}

export async function refreshToken() {
  const token = getSession(REFRESH_TOKEN_KEY);

  try {
    const response = await axiosInstance.post("/auth/refresh-token/admin", {
      refreshToken: token,
    });
    const { data } = response?.data;

    if (!data) {
      flushSession();
    }

    setSession(ACCESS_TOKEN_KEY, data?.accessToken || "");
    setSession(REFRESH_TOKEN_KEY, data?.refreshToken || "");

    return {
      accessToken: data?.accessToken || "",
      refreshToken: data?.refreshToken || "",
    };
  } catch (error) {
    flushSession();
    return null;
  }
}
